import React, { useEffect, useState } from "react";
import { performPostRequest } from "../../service/network/NetworkService";
import { getApiUrl } from "../../service/network/UrlMapper";
import IntentType from "../../intentexecutor/utils/IntentType";
import { useGetOrgIdentifier } from "../generic/hooks/useGetOrgIdentifier";

const Banner = () => {
  const organizationIdentifier = useGetOrgIdentifier();
  const [bannerContent, setBannerContent] = useState(null);

  useEffect(() => {
    const getBannerContent = async () => {
      try {
        const payload = {
          intent: "get_configuration",
          payload: {
            configurationKey: ["niramaya.app.banner.content"],
          },
          context: {
            organizationIdentifier,
          },
        };
        const result = await performPostRequest(
          getApiUrl()[IntentType.GET_CONFIGURATION],
          JSON.stringify(payload)
        );
        const response = await result.json();
        const content = JSON.parse(response[0].configurationValue || "{}");
        setBannerContent(content);
      } catch (err) {
        setBannerContent(null);
      }
    };

    getBannerContent();
  }, [organizationIdentifier]);

  return (
    <>
      {bannerContent?.visibility && (
        <div
          style={{
            backgroundColor: bannerContent?.backgroundColor,
            textAlign: "center",
          }}
        >
          <span>{bannerContent?.enviroment}</span>{" "}
          {bannerContent?.enviroment && " - "}
          <span>{bannerContent?.message}</span>
        </div>
      )}
    </>
  );
};

export default Banner;
